import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import Login from './Login.js';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { MantineProvider } from '@mantine/core'
import { Provider } from 'react-redux';
import store from './redux/store';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <MantineProvider>
        <Provider store={store}>
            <BrowserRouter>
                <React.StrictMode>
                    <Login />
                </React.StrictMode>
            </BrowserRouter>
        </Provider>
    </MantineProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
